module.exports = __webpack_public_path__ + "images/status-waitpay.79487ef5.png";